<template>
  <div class="d-flex align-items-center">
    <div
      class="taco-img"
      :class="'taco-rating-' + data.value"
    />
    <span class="ml-2">&amp; Up</span>
  </div>
</template>

<script>
export default {
  name: 'DropdownElementTaco',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="scss" scoped>
  .taco-img {
    height: 20px;
    width: 100%;
    max-width: 125px;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>
